module.exports = __webpack_public_path__ + "static/media/santa-rita-login.50d120d7.svg";